'use client'
import { ProviderEnum } from '@dynamic-labs/sdk-api-core';

/**
 * Registry of provider display modes (iframe or popup)
 *
 * This mapping controls how each onramp provider is displayed in the UI.
 * - 'popup': Opens in a new browser window/tab
 * - 'iframe': Embedded directly in the current page
 */
const providerDisplayModes = {
    [ProviderEnum.CoinbaseOnramp]: 'popup',
    // Default for other providers is iframe
};

export { providerDisplayModes };
